module.exports = __webpack_public_path__ + "img/20191019153721038.d91710ec.jpg";